<template>
  <div class="col-md-12" style="">
    <h4 style="margin-top:5px;">Animal Details
       <b-button class="float-right" @click="go_back" variant="danger">
          <b-icon-arrow-left-circle-fill></b-icon-arrow-left-circle-fill> Back
      </b-button>
    </h4>
    
    <hr />
    <div class="col-12" style="margin-top: 30px">
      <b-card-text>
        <center>
          <img src="../assets/123.jpg" height="250px" /><br />
          <!-- <h7><b>Name:Buffalo</b></h7
          ><br />
          <h7><b>Type:</b></h7
          ><br />
          <h7><b>Amount:10000</b></h7
          ><br />
          <h7><b>Tag No:</b></h7
          ><br />
          <h7><b>Daily Milk:</b></h7> -->
        </center>
      </b-card-text>
     <table style="" width="100%" border="0">
            <br />

            <tr>
              <td width="45%" style="text-align: left">Tag No</td>
              <td width="1%" style="text-align: left">:</td>
              <td width="54%" style="text-align: left">12</td>
            </tr>

            <tr>
              <td width="45%" style="text-align: left">Type</td>
              <td width="1%" style="text-align: left">:</td>
              <td width="54%" style="text-align: left">Buffalo</td>
            </tr>
            <tr>
              <td width="45%" style="text-align: left">Breed</td>
              <td width="1%" style="text-align: left">:</td>
              <td width="54%" style="text-align: left">Bhadawari</td>
            </tr>
            <!-- <tr>
              <td width="45%" style="text-align: left">Breed Name</td>
              <td width="1%" style="text-align: left">:</td>
              <td width="54%" style="text-align: left">Badri</td>
            </tr> -->
            <tr>
              <td width="45%" style="text-align: left">Age</td>
              <td width="1%" style="text-align: left">:</td>
              <td width="54%" style="text-align: left">3 Years</td>
            </tr>
            <tr>
              <td width="45%" style="text-align: left">Amount</td>
              <td width="1%" style="text-align: left">:</td>
              <td width="54%" style="text-align: left">50.000</td>
            </tr>
            <tr>
              <td width="45%" style="text-align: left">In milking Days</td>
              <td width="1%" style="text-align: left">:</td>
              <td width="54%" style="text-align: left">Yes,Milking</td>
            </tr>
            <tr>
              <td width="45%" style="text-align: left">milking Yeild</td>
              <td width="1%" style="text-align: left">:</td>
              <td width="54%" style="text-align: left">10L</td>
            </tr>
            <tr>
              <td width="45%" style="text-align: left">Is Pregnant</td>
              <td width="1%" style="text-align: left">:</td>
              <td width="54%" style="text-align: left">No</td>
            </tr>
            <tr>
              <td width="45%" style="text-align: left">No of Parturition</td>
              <td width="1%" style="text-align: left">:</td>
              <td width="54%" style="text-align: left">2</td>
            </tr>
            <tr>
              <td width="45%" style="text-align: left">Pregnancy month</td>
              <td width="1%" style="text-align: left">:</td>
              <td width="54%" style="text-align: left">-</td>
            </tr>
            <tr>
              <td width="45%" style="text-align: left">Is Calveh</td>
              <td width="1%" style="text-align: left">:</td>
              <td width="54%" style="text-align: left">Yes</td>
            </tr>
            <tr>
              <td width="45%" style="text-align: left">Last Calve Date</td>
              <td width="1%" style="text-align: left">:</td>
              <td width="54%" style="text-align: left">20-07-2020</td>
            </tr>

            <tr>
              <td width="45%" style="text-align: left">Last Calve Gender</td>
              <td width="1%" style="text-align: left">:</td>
              <td width="54%" style="text-align: left">Male</td>
            </tr>

            <br />
            <tr></tr>
            <br />
          </table>
      <div class="btn-group col-12">
        <button type="button" class="btn btn-xs btn-success col-4" @click="handleSell">
          Sell
        </button>&nbsp;
        <button type="button" class="btn btn-xs btn-primary col-4" @click="send_enquiry">
          Edit/Update</button
        >&nbsp;
        <button type="button" class="btn btn-xs btn-danger col-4" @click="add_to_cart">
          Delete
        </button>
      </div>
        <hr />
        <div class="btn-group col-12">
        <button
          type="button"
          class="btn btn-xs btn-success col-6"
          @click="handleSell1"
        >
          Add Vaccination</button
        >&nbsp;
        <button
          type="button"
          class="btn btn-xs btn-primary col-6"
          @click="handleSell2"
        >
          Add Insurance
        </button>
      </div>
      <br />


      </div><br>
    
  </div>
</template>
<script>
export default {
  data() {
    return {
      tabIndex: 0,
    };
  },
  methods: {
    handleSell(){
      this.$router.push('/home/Add_for_sell');
    },
    go_back() {
      this.$router.go(-1);
    },
    add_to_cart() {
      alert("Added To Cart");
    },
    send_enquiry() {
      alert("Enquiry send to seller");
    },
  },
};
</script>